<template>
  <div :class="['flex', alignment === 'horizontal' ? 'flex-row space-x-4 my-4' : 'flex-col space-y-4 my-8']">
    <div
      v-for="(step, index) in steps"
      :key="index"
      class="flex items-center relative"
      :class="alignment === 'horizontal' ? 'flex-1 container-horizontal flex-col' : 'container-vertical'">
      
      <span v-if="alignment === 'horizontal'" class="text-sm font-medium mb-3 text-[#000000]">{{ step }}</span>
      <!-- Completed Steps -->
      <svg
        v-if="index < currentIndex"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        class="mr-2">
        <circle cx="8" cy="8" r="8" fill="#74979a"></circle>
        <path d="M11.3337 5.5L6.75033 10.0833L4.66699 8" stroke="#ffffff" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>

      <!-- Current Step -->
      <svg
        v-else-if="index === currentIndex"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        class="mr-2">
        <circle cx="8" cy="8" r="7" stroke="#74979a" stroke-width="2" fill="none"></circle>
        <circle cx="8" cy="8" r="3.5" fill="#74979a"></circle>
      </svg>

      <!-- Next Steps -->
      <svg
        v-else
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        class="mr-2">
        <circle cx="8" cy="8" r="7" stroke="#74979a" stroke-width="2" fill="none"></circle>
      </svg>

      <!-- Connector Line -->
      <div
        v-if="index < steps.length - 1"
        :class="alignment === 'horizontal' ? 'line-horizontal left-[56%] sm:left-[55%] md:left-[55.5%]' : 'line-vertical'">
      </div>

      <!-- Step Label -->
      <span v-if="alignment === 'vertical'" class="text-sm font-medium text-[#000000]">{{ step }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    steps: {
      type: Array,
      required: true,
    },
    currentIndex: {
      type: Number,
      required: true,
    },
    // alignment: {
    //   type: String,
    //   default: "horizontal", // Can be 'horizontal' or 'vertical'
    //   validator: (value) => ["horizontal", "vertical"].includes(value),
    // },
  },

  data() {
    return {
      alignment: "vertical", // Default alignment
    };
  },
  mounted() {
    this.updateAlignment(); // Set initial alignment based on screen width
    window.addEventListener("resize", this.updateAlignment); // Update alignment on screen resize
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateAlignment); // Clean up event listener
  },
  methods: {
    updateAlignment() {
      // Change alignment based on screen width
      this.alignment = window.innerWidth >= 400 ? "horizontal" : "vertical";
    },
  },
};
</script>

<style scoped>
  .line-vertical {
    width: 2px;
    height: 10px;
    background-color: #74979a;
    position: absolute;
    top: 20px;
    left: 7px;
  }

  .line-horizontal {
    position: absolute;
    height: 3px;
    background: #74979a;
    width: 93%;
    top: 36px;
  }
</style>